import React from 'react';
import { UserProvider } from './../Providers/UserProvider';
import { Routes } from './../Core/Constants'

export default class LeafletBox extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			email: '',
			error: null
		};
	}

	handleSubmit = (e) => {
		var T = window.Texts.newsBox;
		e.preventDefault();
		this.setState({ error: null });
		UserProvider.leafletsignup(this.state.email,
			() => {
				alert(T.finish);
				this.setState({ email: '' });
			},
			(err) => {
				this.setState({ error: err });
			});

	}

	render() {
		var T = window.Texts.newsBox;
		return (
			<div class="cover">
				<h4 dangerouslySetInnerHTML={{ __html: T.leaf2EmalH1}} />
				<form className="leaflet-form" id="newsLetterRow">
					<input className="required email form-control" name="Email" type="text" />
					<button className="btn" type="submit">{T.sendLeaflet}</button>
					<p className="gdpr_news">
						<a target="_blank" href={Routes.Home + 'Home/Page/Protection#gdpr_news'}>{T.souhlasSeZpracovanimOsobnichUdaju}</a>
					</p>
				</form>
			</div>);
		}
	}
	
var element = document.getElementById("app-leafletBox");
if (element) {
	ReactDOM.render(<LeafletBox />, element);
}
